import * as yup from 'yup';
import axios from 'axios';
import { apiProxy } from '../util-lib/http';
import { ensureParams } from '../util-lib/api-proxy';
/**
 * 获取服务器时间
 */
export async function getNowTime() {
  return axios.get('/tantu/webapp/api/getNowTime');
}

/**
 * 获取优惠卷
 * @param {string} type 卷类型
 * @param {string} userid 用户id
 */
export async function getCoupon(params = getCoupon._definedParams) {
  params = ensureParams(params, getCoupon._definedParams);
  const api = 'api/v1.21/Hotel/Activity/Unionpay/Coupon/receive';
  const data = await apiProxy.post(api, params);
  return data;
}

getCoupon._definedParams = {
  userid: '',
  type: ''
};

/**
 * 获取优惠卷状态
 * @param {string} userid 用户id
 */
export async function checkCouponStatus(params = checkCouponStatus._definedParams) {
  params = ensureParams(params, checkCouponStatus._definedParams);
  const api = 'api/v1.21/Hotel/Activity/Unionpay/Coupon/receiveStatus';
  const data = await apiProxy.post(api, params);
  return data;
}

checkCouponStatus._definedParams = {
  userid: ''
};


getPoiGoods._definedParams = {
  activity: '' // 兼容6月和7月的银联活动，6月：62percent 7月：50percent
};

/**
 * 获取poi商品
 */
export async function getPoiGoods(params = getPoiGoods._definedParams) {
  params = ensureParams(params, getPoiGoods._definedParams);
  const api = 'api/v1.21/Poi/Activity/UnionPayGoods';
  const data = await apiProxy.post(api, params);
  return data;
}

/**
 * 获取酒店商品
 */
export async function getHotelGoods() {
  const api = 'api/v1.21/Hotel/Activity/Unionpay/SaleHotels';
  const data = await apiProxy.post(api);
  return data;
}

getHotelGoodsV2._definedParams = {
  page_id: 0
};

/**
 * 获取酒店商品V2 七月银联活动专用
 */
export async function getHotelGoodsV2(params = getHotelGoodsV2._definedParams) {
  params = ensureParams(params, getHotelGoodsV2._definedParams);
  const api = 'api/v1.21/Hotel/Activity/Unionpay/SaleHotelsV2';
  const data = await apiProxy.post(api, params);
  return data;
}


/**
 * 获取优惠卷状态v2 七月银联活动专用
 * @param {string} userid 用户id
 */
export async function checkCouponStatusV2(params = checkCouponStatusV2._definedParams) {
  params = ensureParams(params, checkCouponStatusV2._definedParams);
  const api = 'api/v1.21/Hotel/Activity/Unionpay/Coupon/ReceiveStatusV2';
  const data = await apiProxy.post(api, params);
  return data;
}

checkCouponStatusV2._definedParams = {
  userid: '',
  page_id: 0
};

/**
 * 获取优惠卷v2 银联优惠券专用
 * @param {string} type 卷类型
 * @param {string} userid 用户id
 */
export async function getCouponV2(params = getCouponV2._definedParams) {
  params = ensureParams(params, getCouponV2._definedParams);
  const api = 'api/v1.21/Hotel/Activity/Unionpay/Coupon/ReceiveV2';
  const data = await apiProxy.post(api, params);
  return data;
}

getCouponV2._definedParams = {
  userid: '',
  type: '',
  page_id: 0
};
getGoodsActivity._definedParams = {
  goodsId: ''
};

/**
 * 获取商品详情商品的活动信息
 */
export async function getGoodsActivity(params = getGoodsActivity._definedParams) {
  params = ensureParams(params, getGoodsActivity._definedParams);
  const dataSchema = yup.object().shape({
    getGoodsActivity: yup.object().shape({
      data: yup.object().shape({
        pinActivity: yup.object().shape({
          pinPrice: yup.number(),
          pinUrl: yup.string()
        }).nullable(),
        topicActivity: yup.object().shape({
          title: yup.string(),
          url: yup.string()
        }).nullable()
      })
    })
  });
  const api = 'api/v1.0/Poi/Goods/GoodsActivity';
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.getGoodsActivity.data;
}
